import Vue from "vue";
import Router from "vue-router";
import store from "../store";

import layout from "../layout";

const AUTHTOKEN_ASSUMED = "AUTHTOKEN_ASSUMED";
const USERPROFILE_REQUEST = "USERPROFILE_REQUEST";
const CUSTOMERPROFILE_REQUEST = "CUSTOMERPROFILE_REQUEST";
const SERVICES_REQUEST = "SERVICES_REQUEST";
const SITES_REQUEST = "SITES_REQUEST";
const SITE_CHECKINS_REQUEST_ALL = "SITE_CHECKINS_REQUEST_ALL";
const USERS_REQUEST = "USERS_REQUEST";
const USERS_ITEMS_NEEDING_ATTENTION = "USERS_ITEMS_NEEDING_ATTENTION";
const EVENTS_REQUEST = "EVENTS_REQUEST";
const ALL_CUSTOMERPROFILES_REQUEST = "ALL_CUSTOMERPROFILES_REQUEST";
const NOTIFICATIONS_REQUEST = "NOTIFICATIONS_REQUEST";
const CONTACTS_REQUEST = "CONTACTS_REQUEST";
const FAQ_REQUEST = "FAQ_REQUEST";
const JOBSTATUS_REQUEST = "JOBSTATUS_REQUEST";
const SERVICES_THIRD_PARTY_REQUEST = "SERVICES_THIRD_PARTY_REQUEST";
const EQUIPMENT_REQUEST = "EQUIPMENT_REQUEST";
const DEFAULT_TITLE = 'VERNet Service Portal';
const CUSTOMER_LINKS_REQUEST = "CUSTOMER_LINKS_REQUEST";
const SERVICE_LINKS_REQUEST = "SERVICE_LINKS_REQUEST";
//const CUSTOMER_ICON_REQUEST = "CUSTOMER_ICON_REQUEST"
//const TICKETS_REQUEST = "TICKETS_REQUEST";

Vue.use(Router);

const ifAuthenticated = (to, from, next) => {

    
    if (Vue.prototype.$token) {
        store.commit(AUTHTOKEN_ASSUMED, Vue.prototype.$token);
        if (!store.getters.isProfileLoaded || !store.getters.isCustomerProfileLoaded || !store.getters.isServicesListLoaded || !store.getters.isSitesListLoaded) {
            store.dispatch(USERPROFILE_REQUEST).then(() => {

                store.dispatch(USERS_ITEMS_NEEDING_ATTENTION).then(() => {
                })
                .catch((resp) => {
                    Vue.prototype.$snotify.warning((resp.message ? resp.message : "An error occurred retrieving items needing attention"), {
                        timeout: 2000,
                        showProgressBar: false,
                        closeOnClick: false,
                        pauseOnHover: true,
                    });
                    next()
                });

                //Load Site Checkins for VERNet staff and Field Technicians
                if(store.getters.getProfileType === 1 || store.getters.getProfileType === 2 || store.getters.getProfileType === 3){
                    store.dispatch(SITE_CHECKINS_REQUEST_ALL).then(() => {
                    })
                    .catch((resp) => {
                        Vue.prototype.$snotify.warning((resp.message ? resp.message : "An error occurred retrieving items needing attention"), {
                            timeout: 2000,
                            showProgressBar: false,
                            closeOnClick: false,
                            pauseOnHover: true,
                        });
                        next()
                    });
                }

                if(store.getters.getProfileType === 1){
                    store.dispatch(JOBSTATUS_REQUEST).then(() => {
                    })
                        .catch((resp) => {
                            Vue.prototype.$snotify.warning((resp.message ? resp.message : "An error occurred retrieving AWX Jobs"), {
                                timeout: 2000,
                                showProgressBar: false,
                             closeOnClick: false,
                                pauseOnHover: true,
                            });
                            next()
                        });
                }

                if(store.getters.getProfileType === 1 || store.getters.getProfileType === 2 || store.getters.getProfileType === 3){
                    store.dispatch(EQUIPMENT_REQUEST).then(() => {
                    })
                        .catch((resp) => {
                            Vue.prototype.$snotify.warning((resp.message ? resp.message : "An error occurred retrieving Equipment"), {
                                timeout: 2000,
                                showProgressBar: false,
                             closeOnClick: false,
                                pauseOnHover: true,
                            });
                            next()
                        });
                }
            
                store.dispatch(CUSTOMERPROFILE_REQUEST).then(() => {
                    if (store.getters.isAuthenticated) {
                        if (store.getters.getProfileType === 1 || store.getters.getProfileType === 4 || store.getters.getProfileType === 5)
                        {
                            store.dispatch(USERS_REQUEST).then(() => {
                                next()
                            })
                                .catch((resp) => {
                                    Vue.prototype.$snotify.warning((resp.message ? resp.message : "An error occurred retrieving users"), {
                                        timeout: 2000,
                                        showProgressBar: false,
                                        closeOnClick: false,
                                        pauseOnHover: true,
                                    });
                                    next()
                                });
                        } else {
                            next()
                        }
                        store.dispatch(ALL_CUSTOMERPROFILES_REQUEST).then(() => {
                            if(store.getters.getProfileType === 1){
                                store.dispatch(CUSTOMER_LINKS_REQUEST).then(() => {})
                                store.dispatch(SERVICE_LINKS_REQUEST).then(() => {})
                            .catch((resp) => {
                                Vue.prototype.$snotify.warning((resp.message ? resp.message : "An error occurred retrieving Customer Links"), {
                                    timeout: 2000,
                                    showProgressBar: false,
                                closeOnClick: false,
                                    pauseOnHover: true,
                                });
                                next()
                            });
                        }
/*                             for(let thisCustomer of store.getters.getAllCustomerProfiles){
                                store.dispatch(CUSTOMER_ICON_REQUEST, thisCustomer.customerid)
                            } */
                        })
                        .catch((resp) => {
                            Vue.prototype.$snotify.warning((resp.message ? resp.message : "An error occurred retrieving customer profiles"), {
                                timeout: 2000,
                                showProgressBar: false,
                                closeOnClick: false,
                                pauseOnHover: true,
                            });
                            next()
                        });
                    }
                    if(store.getters.getProfileType !== 2){
                          store.dispatch(CONTACTS_REQUEST).then(() => {})
                        .catch((resp) => {
                            Vue.prototype.$snotify.warning((resp.message ? resp.message : "An error occurred retrieving Site Contacts"), {
                                timeout: 2000,
                                showProgressBar: false,
                                closeOnClick: false,
                                pauseOnHover: true,
                            });
                            next()
                        });
                    }
                  
                //store.dispatch(TICKETS_REQUEST).then(() => {

                    if (store.getters.getProfileType === 2) //If they're a Field Tech, they only need Sites.
                    {
                        store.dispatch(SITES_REQUEST).then(() => { //Sites are last so they can use Services to compare against Events.
                        })
                        .catch((resp) => {
                            Vue.prototype.$snotify.warning((resp.message ? resp.message : "An error occurred retrieving sites"), {
                                timeout: 2000,
                                showProgressBar: false,
                                closeOnClick: false,
                                pauseOnHover: true,
                            });
                            next()
                        });
                        store.dispatch(FAQ_REQUEST).then(() => {
                        })
                            .catch((resp) => {
                                Vue.prototype.$snotify.warning((resp.message ? resp.message : "An error occurred retrieving FAQ articles"), {
                                    timeout: 2000,
                                    showProgressBar: false,
                                    closeOnClick: false,
                                    pauseOnHover: true,
                                });
                                next()
                            });
                    } else{
                        store.dispatch(NOTIFICATIONS_REQUEST).then(() => {
                        })
                            .catch((resp) => {
                                Vue.prototype.$snotify.warning((resp.message ? resp.message : "An error occurred retrieving notifications"), {
                                    timeout: 2000,
                                    showProgressBar: false,
                                    closeOnClick: false,
                                    pauseOnHover: true,
                                });
                                next()
                            });                   
                    store.dispatch(FAQ_REQUEST).then(() => {})
                    .catch((resp) => {
                        Vue.prototype.$snotify.warning((resp.message ? resp.message : "An error occurred retrieving FAQ articles"), {
                            timeout: 2000,
                            showProgressBar: false,
                            closeOnClick: false,
                            pauseOnHover: true,
                        });
                        next()
                    });
                    store.dispatch(EVENTS_REQUEST).then(() => { //Load Events first so they can be evaluated by services and sites.
                        store.dispatch(SERVICES_REQUEST).then(() => { //Get Services next so they can check events for their status.
                            store.dispatch(SITES_REQUEST).then(() => { //Sites are last so they can use Services to compare against Events.
                            })
                            .catch((resp) => {
                                Vue.prototype.$snotify.warning((resp.message ? resp.message : "An error occurred retrieving sites"), {
                                    timeout: 2000,
                                    showProgressBar: false,
                                    closeOnClick: false,
                                    pauseOnHover: true,
                                });
                                next()
                            });

                            if(store.getters.getProfileType === 1){
                                store.dispatch(SERVICES_THIRD_PARTY_REQUEST).then(() => { //Sites are last so they can use Services to compare against Events.
                                })
                                .catch((resp) => {
                                    Vue.prototype.$snotify.warning((resp.message ? resp.message : "An error occurred retrieving sites"), {
                                        timeout: 2000,
                                        showProgressBar: false,
                                        closeOnClick: false,
                                        pauseOnHover: true,
                                    });
                                    next()
                                })
                            }
                        })
                        .catch((resp) => {
                            Vue.prototype.$snotify.warning((resp.message ? resp.message : "An error occurred retrieving services"), {
                                timeout: 2000,
                                showProgressBar: false,
                                closeOnClick: false,
                                pauseOnHover: true,
                            });
                            next()
                        });  
                    })
                    .catch((resp) => {
                        Vue.prototype.$snotify.warning((resp.message ? resp.message : "An error occurred retrieving events"), {
                            timeout: 2000,
                            showProgressBar: false,
                            closeOnClick: false,
                            pauseOnHover: true,
                    });
                    //Couldn't get Events, calling Services and Sites here so they still get loaded.
                    store.dispatch(SERVICES_REQUEST).then(() => {
                    })
                    .catch((resp) => {
                        Vue.prototype.$snotify.warning((resp.message ? resp.message : "An error occurred retrieving services"), {
                            timeout: 2000,
                            showProgressBar: false,
                            closeOnClick: false,
                            pauseOnHover: true,
                        });
                        next()
                    });
                    if(store.getters.getProfileType === 1){
                            store.dispatch(SERVICES_THIRD_PARTY_REQUEST).then(() => { //Sites are last so they can use Services to compare against Events.
                            })
                            .catch((resp) => {
                                Vue.prototype.$snotify.warning((resp.message ? resp.message : "An error occurred retrieving sites"), {
                                    timeout: 2000,
                                    showProgressBar: false,
                                    closeOnClick: false,
                                    pauseOnHover: true,
                                });
                                next()
                            })
                        }
                        store.dispatch(SITES_REQUEST).then(() => {
                        })
                            .catch((resp) => {
                                Vue.prototype.$snotify.warning((resp.message ? resp.message : "An error occurred retrieving sites"), {
                                    timeout: 2000,
                                    showProgressBar: false,
                                    closeOnClick: false,
                                    pauseOnHover: true,
                                });
                                next()
                            });
                        next()
                        });
                    }
                })
                .catch((resp) => {
                    Vue.prototype.$snotify.warning((resp.message ? resp.message : "An error occurred retrieving all customer profiles"), {
                        timeout: 2000,
                        showProgressBar: false,
                        closeOnClick: false,
                        pauseOnHover: true,
                    });
                    next()
                });
            })
            .catch((resp) => {
                Vue.prototype.$snotify.warning((resp.message ? resp.message : "An error occurred retrieving user profile"), {
                    timeout: 2000,
                    showProgressBar: false,
                    closeOnClick: false,
                    pauseOnHover: true,
                });
                next()
            });
        } else {
            if (store.getters.isAuthenticated) {
                next()
                return
            }
        }
    } else {
        next('/login');
    }
}


const router =  new Router({
    linkExactActiveClass: "active",
    scrollBehavior: () => ({y: 0}),
    mode: "history",
    base: "/",
    routes: [
        {
            path: "/",
            component: layout,
            children: [
                {
                    path: "",
                    name: "dashboard",
                    title: "Dashboard",
                    meta: {title: DEFAULT_TITLE},
                    beforeEnter: ifAuthenticated,
                    component: () => (store.getters.getProfileType == 2 ? import("@/pages/dashboard/index-technician") : import("@/pages/dashboard/index"))
                    //component: () => import("@/pages/dashboard")
                }
            ]
        },
        {
            path: "/services",
            component: layout,
            children: [
                {
                    path: "",
                    name: "AllServices",
                    meta: {title: 'All Services'},
                    beforeEnter: ifAuthenticated,
                    component: () => import("@/pages/services/services")
                },
                {
                    path: "unmanaged",
                    name: "unmanaged",
                    meta: {title: 'Unmanaged Services'},
                    beforeEnter: ifAuthenticated,
                    component: () => import("@/pages/services/unmanaged-services")
                },
                {
                    path: "managed",
                    name: "managed",
                    meta: {title: 'Managed Services'},
                    beforeEnter: ifAuthenticated,
                    component: () => import("@/pages/services/managed-services")
                },
                {
                    path: "vpls-networks",
                    name: "vpls",
                    meta: {title: 'VPLS Networks'},
                    beforeEnter: ifAuthenticated,
                    component: () => import("@/pages/services/vpls-networks")
                },
                {
                    path: "l3vpn",
                    name: "l3vpn",
                    meta: {title: 'L3VPN Services'},
                    beforeEnter: ifAuthenticated,
                    component: () => import("@/pages/services/l3vpns")
                },
                {
                    path: "internet",
                    name: "internet",
                    meta: {title: 'Internet Services'},
                    beforeEnter: ifAuthenticated,
                    component: () => import("@/pages/services/internet-services")
                },
                {
                    path: "thirdparty",
                    name: "thirdparty",
                    meta: {title: 'Third-Party Services'},
                    beforeEnter: ifAuthenticated,
                    component: () => import("@/pages/services/services-third-party")
                },
                {
                    path: "/service/:serviceid",
                    name: "service",
                    meta: {localTitle: true},
                    beforeEnter: ifAuthenticated,
                    component: () => import("@/pages/services/service")
                },
                {
                    path: "deprovision",
                    name: "deprovision",
                    meta: {title: 'Service Deprovisioning'},
                    beforeEnter: ifAuthenticated,
                    component: () => import("@/pages/services/service-decommission")
                },
                {
                    path: "service-notifications",
                    name: "notifications",
                    meta: {title: 'Service Notifications'},
                    beforeEnter: ifAuthenticated,
                    component: () => import("@/pages/services/service-notifications")
                },
                {
                    path: "links",
                    name: "servicelinks",
                    meta: {title: 'Service Links'},
                    beforeEnter: ifAuthenticated,
                    component: () => import("@/pages/services/service-links")
                },
            ]
        },
        {
            path: "/jobs",
            component: layout,
            children: [
                {
                    path: "",
                    name: "jobs",
                    meta: {title: 'AWX Jobs'},
                    beforeEnter: ifAuthenticated,
                    component: () => import("@/pages/jobs/jobs")
                },
            ]
        },
        {
            path: "/colocation",
            component: layout,
            children: [
                {
                    path: "rackspaces",
                    name: "rackspaces",
                    meta: {title: 'VERNet Rackspaces'},
                    beforeEnter: ifAuthenticated,
                    component: () => import("@/pages/colocation/rackspaces")
                },
                {
                    path: "crossconnects",
                    name: "crossconnects",
                    meta: {title: 'VERNet Cross-Connects'},
                    beforeEnter: ifAuthenticated,
                    component: () => import("@/pages/colocation/crossconnects")
                }
            ]
        },
        {
            path: "/equipment",
            component: layout,
            children: [
                {
                    path: "",
                    name: "equipment",
                    meta: {title: 'VERNet Equipment'},
                    beforeEnter: ifAuthenticated,
                    component: () => import("@/pages/equipment/equipment")
                },
                {
                    path: "inventory",
                    name: "inventory",
                    meta: {title: 'Spare Parts Inventory'},
                    beforeEnter: ifAuthenticated,
                    component: () => import("@/pages/equipment/inventory")
                },
                {
                    path: "shelf/:shelfid",
                    name: "shelf",
                    meta: {localTitle: true},
                    beforeEnter: ifAuthenticated,
                    component: () => import("@/pages/equipment/shelf")
                },
                {
                    path: "compare-netbox-config/:shelfName",
                    name: "compare-netbox-config",
                    beforeEnter: ifAuthenticated,
                    component: () => import("@/pages/equipment/compare-netbox-config")
                },
                {
                    path: "sync-physical-inventory/:shelfName",
                    name: "sync-physical-inventory",
                    beforeEnter: ifAuthenticated,
                    component: () => import("@/pages/equipment/sync-physical-inventory")
                },
                {
                    path: "zabbix-triggers",
                    name: "zabbixTriggersMuted",
                    meta: {title: 'Zabbix Triggers'},
                    beforeEnter: ifAuthenticated,
                    component: () => import("@/pages/equipment/zabbixTriggersMuted")
                },
            ]
        },
        {
            path: "/customers",
            component: layout,
            children: [
                {
                    path: "",
                    name: "Customers",
                    meta: {title: 'VERNet Customers'},
                    beforeEnter: ifAuthenticated,
                    component: () => import("@/pages/customers/customers")
                },
                {
                    path: "/customers/links",
                    name: "Customer Links",
                    meta: {title: 'Customer Links'},
                    beforeEnter: ifAuthenticated,
                    component: () => import("@/pages/customers/customerLinks")
                },
                {
                    path: "/customers/:customerid",
                    name: "Customer",
                    meta: {localTitle: true},
                    beforeEnter: ifAuthenticated,
                    component: () => import("@/pages/customers/customer")
                },
            ]
        },
        {
            path: "/contacts",
            component: layout,
            children: [
                {
                    path: "",
                    name: "Contacts",
                    meta: {title: 'VERNet Site Contacts'},
                    beforeEnter: ifAuthenticated,
                    component: () => import("@/pages/contacts/contacts")
                },
                {
                    path: "/contact/:contactid",
                    name: "Contact",
                    meta: {localTitle: true},
                    beforeEnter: ifAuthenticated,
                    component: () => import("@/pages/contacts/contact")
                },
            ]
        },
        {
            path: "/documentation",
            component: layout,
            children: [
                {
                    path: "/documentation/sla-reports",
                    name: "sla-reports",
                    meta: {title: 'VERNet SLA Reports'},
                    beforeEnter: ifAuthenticated,
                    component: () => import("@/pages/documentation/sla-reports")
                },
                {
                    path: "/documentation/service-report",
                    name: "service-report",
                    meta: {title: 'VERNet Service Reports'},
                    beforeEnter: ifAuthenticated,
                    component: () => import("@/pages/documentation/service-report")
                },
                {
                    path: "/documentation/usage-reports",
                    name: "usage-reports",
                    meta: {title: 'VERNet Usage Reports'},
                    beforeEnter: ifAuthenticated,
                    component: () => import("@/pages/documentation/usage-reports")
                },
                {
                    path: "/documentation/changeman-reports",
                    name: "changeman-reports",
                    meta: {title: 'VERNet Change-Management Reports'},
                    beforeEnter: ifAuthenticated,
                    component: () => import("@/pages/documentation/changeman-reports")
                },
                {
                    path: "/documentation/invoices",
                    name: "invoices",
                    meta: {title: 'VERNet Invoices'},
                    beforeEnter: ifAuthenticated,
                    component: () => import("@/pages/documentation/invoices")
                },
                                {
                    path: "/documentation/purchaseorders",
                    name: "purchase-orders",
                    meta: {title: 'VERNet Purchase Orders'},
                    beforeEnter: ifAuthenticated,
                    component: () => import("@/pages/documentation/purchaseorders")
                },
                {
                    path: "/documentation/logs",
                    name: "logs",
                    meta: {title: 'VERNet Logs'},
                    beforeEnter: ifAuthenticated,
                    component: () => import("@/pages/documentation/logs")
                },
            ]
        },
        {
            path: "/tickets",
            component: layout,
            children: [
                {
                    path: "",
                    name: "Tickets",
                    meta: {title: 'VERNet Tickets'},
                    beforeEnter: ifAuthenticated,
                    component: () => import("@/pages/tickets/tickets")
                },
                {
                    path: "/ticket/:ticketid",
                    name: "Ticket",
                    meta: {localTitle: true},
                    beforeEnter: ifAuthenticated,
                    component: () => import("@/pages/tickets/tickets")
                }
            ]
        },
        {
            path: "/vpls",
            component: layout,
            children: [
                {
                    path: "/vpls/:vplsid",
                    name: "vpls-service",
                    meta: {localTitle: true},
                    beforeEnter: ifAuthenticated,
                    component: () => import("@/pages/services/vpls")
                },
            ]
        },
        {
            path: "/l3vpn",
            component: layout,
            children: [
                {
                    path: "/l3vpn/:vpnid",
                    name: "l3vpn-service",
                    meta: {localTitle: true},
                    beforeEnter: ifAuthenticated,
                    component: () => import("@/pages/services/l3vpn")
                },
            ]
        },
        {
            path: "/users",
            component: layout,
            children: [
                {
                    path: "",
                    name: "users",
                    meta: {title: 'VERNet User Management'},
                    beforeEnter: ifAuthenticated,
                    component: () => import("@/pages/users/users")
                },
                {
                    path: "/user/:userid",
                    name: "user",
                    meta: {localTitle: true},
                    beforeEnter: ifAuthenticated,
                    component: () => import("@/pages/users/user")
                },
            ]
        },
        {
            path: "/functions",
            component: layout,
            children: [
                {
                    path: "search-result/:searchParameter",
                    name: "search-result",
                    beforeEnter: ifAuthenticated,
                    component: () => import("@/pages/functions/search-result")
                },
                {
                    path: "state-map",
                    name: "state-map",
                    meta: {title: 'VERNet Network Alert Map'},
                    beforeEnter: ifAuthenticated,
                    component: () => import("@/pages/functions/state-map")
                }
            ]
        },
        {
            path: "/sites",
            component: layout,
            children: [
                {
                    path: "",
                    name: "sites",
                    meta: {title: 'VERNet Sites'},
                    beforeEnter: ifAuthenticated,
                    component: () => import("@/pages/sites/my-sites")
                },
                {
                    path: "/site/:siteid",
                    name: "site",
                    meta: {localTitle: true},
                    beforeEnter: ifAuthenticated,
                    component: () => import("@/pages/sites/site")
                },
                                {
                    path: "/site-inspection/:siteid",
                    name: "site-inspection",
                    meta: {title: 'VERNet Site Inspection Form'},
                    beforeEnter: ifAuthenticated,
                    component: () => import("@/pages/sites/site-inspection")
                },
                {
                    path: "/site/:siteid/photos",
                    name: "site-photos",
                    meta: {localTitle: true},
                    beforeEnter: ifAuthenticated,
                    component: () => import("@/pages/sites/site-photos")
                },
            ]
        },
        {
            path: "/events",
            component: layout,
            children: [
                {
                    path: "",
                    name: "events",
                    meta: {title: 'VERNet Network Events'},
                    beforeEnter: ifAuthenticated,
                    component: () => import("@/pages/events/events")
                },
                {
                    path: "scheduled-events",
                    name: "scheduled-events",
                    meta: {title: 'VERNet Scheduled Events'},
                    beforeEnter: ifAuthenticated,
                    component: () => import("@/pages/events/scheduled-events")
                },
                {
                    path: "past-events",
                    name: "past-events",
                    meta: {title: 'VERNet Past Events'},
                    beforeEnter: ifAuthenticated,
                    component: () => import("@/pages/events/past-events")
                },
                {
                    path: "/event/:eventid",
                    name: "event",
                    meta: {localTitle: true},
                    beforeEnter: ifAuthenticated,
                    component: () => import("@/pages/events/showevent")
                },
            ]
        },
        {
            path: "/login",
            name: "login",
            component: () => import("@/pages/login/login")
        },
        {
            path: "/passwordreset",
            name: "passwordreset",
            meta: {title: 'VERNet Password Reset'},
            component: () => import("@/pages/login/passwordreset")
        },
        {
            path: "/error-pages",
            component: {
                render(c) {
                    return c("router-view");
                }
            },
            children: [
                {
                    path: "error-404",
                    name: "error-404",
                    component: () => import("@/pages/samples/error-pages/error-404")
                },
                {
                    path: "error-500",
                    name: "error-500",
                    component: () => import("@/pages/samples/error-pages/error-500")
                }
            ]
        },
        {
            path: "/general-pages",
            component: layout,
            children: [
                {
                    path: "blank-page",
                    name: "blank-page",
                    component: () => import("@/pages/samples/general-pages/blank-page")
                },
                {
                    path: "customer-faq",
                    name: "customer-faq",
                    meta: {title: 'VERNet FAQ & Knowledgebase'},
                    beforeEnter: ifAuthenticated,
                    component: () => import("@/pages/support/customer-faq")
                },
                {
                    path: "technician-job-creator",
                    name: "technician-job-creator",
                    beforeEnter: ifAuthenticated,
                    component: () => import("@/pages/support/technician-job-creator")
                },
                {
                    path: "customer-faq/:faqarticleid",
                    name: "customer-faq-article",
                    meta: {title: 'VERNet FAQ & Knowledgebase'},
                    beforeEnter: ifAuthenticated,
                    component: () => import("@/pages/support/customer-faq")
                },
                {
                    path: "release-notes",
                    name: "release-notes",
                    meta: {title: 'VERNet Release Notes'},
                    beforeEnter: ifAuthenticated,
                    component: () => import("@/pages/support/release-notes")
                },
            ]
        },
        {
            path: "/uploads",
            component: layout,
            children: [
                {
                    path: "generaluploads",
                    name: "general-uploads",
                    meta: {title: 'VERNet General Uploads'},
                    beforeEnter: ifAuthenticated,
                    component: () => import("@/pages/uploads/generaluploads")
                },
            ]
        },
        {
            path: "*",
            redirect: "/error-404",
            component: {
                render(c) {
                    return c("router-view");
                }
            },
            children: [
                {
                    path: "error-404",
                    component: () => import("@/pages/samples/error-pages/error-404")
                }
            ]
        }
    ]
});

router.afterEach((to) => {
    //Set page title
    Vue.nextTick(() => {
        if(!to.meta.localTitle){ //Anything with 'localTitle doesn't need a title, as the title is generated in-page with dynamic values
                document.title = to.meta.title || DEFAULT_TITLE;
        }
    });
});

export default router;
